import { render, staticRenderFns } from "./AddSupplier.vue?vue&type=template&id=a3d8323c&scoped=true"
import script from "./AddSupplier.vue?vue&type=script&lang=js"
export * from "./AddSupplier.vue?vue&type=script&lang=js"
import style0 from "./AddSupplier.vue?vue&type=style&index=0&id=a3d8323c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d8323c",
  null
  
)

export default component.exports